export const siteInfo = {
  name: "吃瓜深扒社",
  slogan: "深扒选美赛果背后的门道",
  intro:
    "吃瓜深扒社是一个专注选美赛事深度解析的中文内容站。我们不满足于标题式的爆料，而是把评分口径、评委构成、计分流程与合约条款摆到台面上，让每一条关于内定与黑幕的说法都能被对照与复核。",
  positioning:
    "面向关注选美赛事、爱看娱乐爆料，同时希望看到理性复盘的中文读者，提供可核查的赛果解析与规则拆解。",
  email: "contact@chiguashenba.com",
  workingNote: "线索投递与内容纠错全年开放，通常会在三个工作日内回复。",
  stats: [
    { value: "312", label: "已梳理赛事场次" },
    { value: "148", label: "评分口径核对" },
    { value: "47", label: "合约条款拆解" },
    { value: "96%", label: "线索交叉验证率" },
  ],
  principles: [
    {
      icon: "ri-shield-check-line",
      title: "先验证，再表达",
      text: "任何单一线索都必须找到至少一条公开记录作为对照，否则只作为待验证线索标注，不进入结论。",
    },
    {
      icon: "ri-scales-3-line",
      title: "区分事实与推测",
      text: "文中会明确标记哪些是已经确认的流程事实，哪些仍属合理推测，读者可以自行判断可信区间。",
    },
    {
      icon: "ri-eye-off-line",
      title: "保护信源",
      text: "投递者身份信息不对外公开，物料的引用方式以可核查性优先，不以猎奇为优先。",
    },
    {
      icon: "ri-refresh-line",
      title: "允许纠错",
      text: "如果被指出引用有误，我们会更新文章并标注修订时间，而不是悄悄修改或删除。",
    },
  ],
  timeline: [
    {
      year: "2022",
      title: "从一张评分表开始",
      text: "最初只是把一场决赛的三份评分表放在一起对比，发现口径差异足以改变冠军归属，于是开始系统整理。",
    },
    {
      year: "2023",
      title: "建立核对方法",
      text: "摸索出分项名称、权重合计、同分规则三步核对法，并把它变成每篇文章的固定动作。",
    },
    {
      year: "2024",
      title: "扩展到合约与传播",
      text: "开始关注时间条款与通稿发布节奏，把赛果争议放进更长的时间线里理解。",
    },
    {
      year: "2026",
      title: "开放线索通道",
      text: "上线线索投递与纠错通道，让读者提供的公开物料成为选题的重要来源。",
    },
  ],
};

export const testimonials = [
  {
    id: "t1",
    name: "陆一鸣",
    role: "赛事观察爱好者",
    text: "看比赛很多年，一直觉得哪里不对但说不清。这里把权重和同分规则摊开讲之后，我才知道该往哪里看。",
  },
  {
    id: "t2",
    name: "秦悦",
    role: "内容行业从业者",
    text: "难得的是它会把事实和推测分开写，不煽动情绪。做内容的人都知道，这种克制其实更费功夫。",
  },
  {
    id: "t3",
    name: "周迟",
    role: "长期读者",
    text: "投递过一次票数异常记录，编辑做了三轮交叉验证才决定用，还回来告诉我哪部分不能用。挺意外的。",
  },
];